// extracted by mini-css-extract-plugin
export var cancelButton = "_ni-5";
export var content = "_ni-3";
export var createButton = "_ni-6";
export var drawerContainer = "_ni-0";
export var footer = "_ni-2";
export var header = "_ni-1";
export var orderFormColumn = "_ni-4";